<template>
  <v-row>
    <v-col cols="12" sm="5">
      <v-row no-gutters>
        <v-col cols="12" sm="auto">
          <in-place-date-editor
            icon="mdi-calendar"
            v-model="meetingObject.scheduletStartTimeInUTC"
            :endDate.sync="meetingObject.scheduledEndTimeInUTC"
            :lable="$t('agenda.lblStartTime')"
            type="start"
          ></in-place-date-editor>
        </v-col>
        <v-col
          cols="12"
          sm="1"
          style="display: flex; justify-content: center; line-height: 1.25"
        >
          -
        </v-col>
        <v-col cols="12" sm="5" class="text-left">
          <in-place-date-editor
            v-model="meetingObject.scheduledEndTimeInUTC"
            :minDate="meetingObject.scheduletStartTimeInUTC"
            :lable="$t('agenda.lblEndTime')"
            type="end"
          ></in-place-date-editor>
        </v-col>
      </v-row>
      <v-row v-if="!isMeetingTimeValid" class="mt-2">
        <v-col cols="12" class="pt-0">
          <div class="error--text">
            {{ $t("msgInvalidMeetingTime") }}
          </div>
        </v-col>
      </v-row>
      <v-row
        v-if="
          false &&
          meetingObject.startMeetingTime &&
          meetingObject.endMeetingTime
        "
      >
        <v-col cols="12" sm="12">
          <v-row no-gutters>
            <v-col cols="12" sm="auto">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    size="18"
                    color="darkCharcoal"
                    class="mr-2"
                    >mdi-calendar</v-icon
                  >
                  <span v-bind="attrs" v-on="on" class="label-m">
                    {{
                      formatDate(
                        new Date(meetingObject.startMeetingTime),
                        displayDateFormat
                      )
                    }}
                  </span>
                </template>
                <span>{{ $t("agenda.lblActualStartTime") }}</span>
              </v-tooltip>
            </v-col>
            <v-col
              cols="12"
              sm="1"
              style="display: flex; justify-content: center; line-height: 1.25"
            >
              -
            </v-col>
            <v-col cols="12" sm="5" class="text-left">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    size="18"
                    color="darkCharcoal"
                    class="mr-2"
                    >mdi-calendar</v-icon
                  >
                  <span v-bind="attrs" v-on="on" class="label-m">
                    {{
                      formatDate(
                        new Date(meetingObject.endMeetingTime),
                        displayDateFormat
                      )
                    }}</span
                  >
                </template>
                <span>{{ $t("agenda.lblActualEndTime") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="7">
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="4">
          <in-place-text-field-editor
            v-model="meetingObject.resolutionType"
            icon="mdi-text-box-check-outline"
            :lable="$t('agenda.lblResType')"
            type="select"
            field="resolutionType"
          ></in-place-text-field-editor>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="4">
          <in-place-text-field-editor
            v-model="meetingObject.location"
            icon="mdi-map-marker-radius"
            :lable="$t('agenda.lblMeetingLocation')"
          ></in-place-text-field-editor>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="4">
          <in-place-text-field-editor
            v-model="meetingObject.meetingType"
            type="meetingType"
            icon="mdi-human-male-board-poll"
            :lable="$t('agenda.lblMeetingType')"
            :isEditable="false"
          ></in-place-text-field-editor>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { formatDate } from "@/utils/util";
import InPlaceTextFieldEditor from "../InPlaceTextFieldEditor.vue";
import InPlaceDateEditor from "../InPlaceDateEditor.vue";
export default {
  components: { InPlaceTextFieldEditor, InPlaceDateEditor },
  name: "AgendaMeetingDetailsCard",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isMeetingTimeValid: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    displayDateFormat() {
      return this.locale !== "ja" ? "dd/MM/yyyy h:mm aaa" : "yyyy/MM/dd HH:mm";
    },
    meetingObject: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style scoped>
.v-tooltip {
  z-index: 10003 !important;
}
</style>